import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const MotorcycleSelector = ({ motorcycles, selectedMotorcycle, onSelect }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
          Pilih Motor Honda
        </h3>
        <span className="text-sm text-muted-foreground">
          {motorcycles?.length} Model Tersedia
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {motorcycles?.map((motor) => (
          <button
            key={motor?.id}
            onClick={() => onSelect(motor)}
            className={`relative p-4 rounded-lg border-2 transition-all duration-300 text-left ${
              selectedMotorcycle?.id === motor?.id
                ? 'border-primary bg-primary/5 shadow-honda-subtle'
                : 'border-border bg-card hover:border-primary/50 hover:shadow-card-hover'
            }`}
          >
            {motor?.isPopular && (
              <div className="absolute top-2 right-2 px-2 py-1 bg-primary text-primary-foreground text-xs font-heading font-semibold rounded">
                Populer
              </div>
            )}

            <div className="aspect-[4/3] mb-3 overflow-hidden rounded-lg bg-muted">
              <Image
                src={motor?.image}
                alt={motor?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>

            <h4 className="font-heading font-bold text-base text-foreground mb-1">
              {motor?.name}
            </h4>
            <p className="text-sm text-muted-foreground mb-3 line-clamp-1">
              {motor?.type}
            </p>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-muted-foreground">Harga OTR</p>
                <p className="text-lg font-heading font-bold text-primary">
                  Rp {motor?.price?.toLocaleString('id-ID')}
                </p>
              </div>
              {selectedMotorcycle?.id === motor?.id && (
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                  <Icon name="Check" size={18} color="white" strokeWidth={3} />
                </div>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MotorcycleSelector;